import React from 'react';
import { FadeIn } from './FadeIn';
const events = [{
  month: 'NOV',
  day: '12',
  title: 'Kingdom Leadership Summit',
  location: 'Atlanta, GA • Main Auditorium',
  time: '9:00 AM - 4:00 PM EST'
}, {
  month: 'NOV',
  day: '24',
  title: 'Prophetic Encounter Night',
  location: 'Online Global Broadcast',
  time: '7:00 PM EST'
}, {
  month: 'DEC',
  day: '05',
  title: 'Annual Ministry Conference',
  location: 'Dallas, TX • Convention Center',
  time: 'Multi-day Event'
}];
export function EventsSection() {
  return <section id="events" className="py-24 md:py-32 bg-dark" data-id="element-97">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-98">
        <FadeIn className="text-center mb-16" data-id="element-99">
          <span className="text-gold font-semibold tracking-[0.2em] text-sm uppercase mb-4 block" data-id="element-100">
            Upcoming
          </span>
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-white" data-id="element-101">
            Events & Conferences
          </h2>
        </FadeIn>

        <div className="space-y-0 border-t border-white/10" data-id="element-102">
          {events.map((event, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-103">
              <div className="group flex flex-col md:flex-row md:items-center justify-between py-8 border-b border-white/10 hover:bg-white/[0.02] transition-colors px-4 -mx-4 rounded-sm" data-id="element-104">
                <div className="flex items-start md:items-center gap-6 md:gap-12 mb-6 md:mb-0" data-id="element-105">
                  {/* Date Badge */}
                  <div className="flex flex-col items-center justify-center w-20 h-24 bg-charcoal border border-gold/20 rounded-sm shrink-0 group-hover:border-gold/50 transition-colors" data-id="element-106">
                    <span className="text-gold text-sm font-semibold tracking-wider" data-id="element-107">
                      {event.month}
                    </span>
                    <span className="text-white text-3xl font-playfair font-bold" data-id="element-108">
                      {event.day}
                    </span>
                  </div>

                  {/* Event Details */}
                  <div data-id="element-109">
                    <h3 className="text-2xl md:text-3xl font-playfair font-bold text-white mb-2 group-hover:text-gold transition-colors" data-id="element-110">
                      {event.title}
                    </h3>
                    <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-6 text-gray-400 font-inter text-sm" data-id="element-111">
                      <span data-id="element-112">{event.location}</span>
                      <span className="hidden sm:block w-1 h-1 bg-gold/50 rounded-full" data-id="element-113" />
                      <span data-id="element-114">{event.time}</span>
                    </div>
                  </div>
                </div>

                {/* CTA */}
                <div className="md:ml-6 shrink-0" data-id="element-115">
                  <a href="#" className="inline-block px-8 py-3 border border-gold text-gold hover:bg-gold hover:text-dark font-semibold tracking-wide transition-all duration-300 rounded-sm w-full text-center" data-id="element-116">
                    Register
                  </a>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} className="mt-12 text-center" data-id="element-117">
          <a href="#" className="text-white/60 hover:text-gold text-sm font-semibold tracking-wide transition-colors uppercase" data-id="element-118">
            View Full Calendar
          </a>
        </FadeIn>
      </div>
    </section>;
}